import React from 'react'
import styled from 'styled-components'
import tinycolor from 'tinycolor2'
import _ from 'lodash'

import Card from '../../atoms/Card'
import Slider from '../../atoms/Slider'
import theme from '../../../theme'

const StyledCard = styled(Card)`
  padding-top: 40px;
  padding-bottom: 60px;
  padding-right: 40px;
  padding-left: 40px;
  overflow: initial;

  &>* {
    margin-bottom: 8px;
  }

  &>*:last-child {
    margin-bottom: 0;
  }
`

export default class ResearchTimePeriodSelector extends React.PureComponent {
  static defaultProps = {
    range: [0, 0],
    start: 0,
    end: 0
  }

  get value() {
    if (this.props.marks) {
      let invertedMarks = _.invert(this.props.marks)
      return [
        +(invertedMarks[this.props.start] || 0),
        +(invertedMarks[this.props.end] || (Object.keys(invertedMarks).length - 1))
      ]
    } else {
      return [
        this.props.start - _.min(this.props.range),
        this.props.end - _.min(this.props.range)
      ]
    }
  }

  handleTimelineChange = ([ firstHandle, secondHandle ]) => {
    if (this.props.onStartChange && this.props.onEndChange) {
      let start = firstHandle + _.min(this.props.range)
      let end = secondHandle + _.min(this.props.range)

      if (this.props.marks) {
        start = +(this.props.marks[firstHandle])
        end = +(this.props.marks[secondHandle])
      }

      if (start !== this.props.start) {
        this.props.onStartChange(start)
      } else {
        this.props.onEndChange(end)
      }
    }
  }

  generateMarks() {
    if (this.props.marks) {
      return this.props.marks
    }

    let start = this.props.range[0]
    let end = this.props.range[1]

    if (start <= end) {
      end += 1
    } else {
      end -= 1
    }

    return _.reduce(_.range(start, end), (object, year, index) => {
      object[index] = `${year}`
      return object
    }, {})
  }

  render() {
    let marks = this.generateMarks()

    return (
      <StyledCard>
        <Slider
          allowCross={ false }
          defaultValue={[ 0, 1 ]}
          marks={ marks }
          min={ 0 }
          max={ _.keys(marks).length - 1 }
          onChange={ this.handleTimelineChange }
          value={ this.value }
          dotStyle={{
            visibility: 'hidden'
          }}
          activeDotStyle={{
            visibility: 'hidden'
          }}
          handleStyle={[
            {
              backgroundColor: theme.colors.main,
              borderColor: theme.colors.main,
              height: '10px',
              marginTop: '-3px',
              width: '10px'
            },
            {
              backgroundColor: theme.colors.main,
              borderColor: theme.colors.main,
              height: '10px',
              marginTop: '-3px',
              width: '10px'
            }
          ]}
          railStyle={{
            backgroundColor: 'white'
          }}
          trackStyle={[
            {
              backgroundColor: tinycolor(theme.colors.main).lighten(20).toString(),
              borderColor: tinycolor(theme.colors.main).lighten(20).toString(),
            }
          ]}
          step={ 1 }
        />
      </StyledCard>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/ResearchTimePeriodSelector/ResearchTimePeriodSelector.js